export const TOOLBAR_HEIGHT_LG = 64;
export const TOOLBAR_HEIGHT_XS = 56;
export const SIDEBAR_RESIZE_BREAKPOINT = 1200;
export const COMPACT_MENU_WIDTH = 64;
